import { Tooltip as MuiTooltip } from '@material-ui/core'
import React, { forwardRef } from 'react'

import { TooltipProps } from './TooltipProps'
import { useTooltipStyles } from './TooltipStyles'

export const Tooltip = forwardRef<HTMLElement, TooltipProps>((props, ref) => {
  const classes = useTooltipStyles(props)
  return <MuiTooltip ref={ref} classes={classes} {...props} />
})

Tooltip.displayName = 'Tooltip'
